import { message } from "antd";
import axios from "axios";
import moment from "moment";
import {
  API_BASE_PATH,
} from "../config";
import { isSessionEnded } from "./session";


// const REACT_APP_BASE_URL = "https://rapsap-api-sod9.onrender.com";
// const apiBaseUrl = `${REACT_APP_BASE_URL}/api/v1/`;

// { ...payload, store_id: 7 }

export async function postApiRaw(
  payload = {},
  apiName = "",
  apiUrl = "dashboard/"
) {
  const tokenString = localStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  try {
    const response = await axios.post(
      API_BASE_PATH + apiUrl + apiName,
      payload,
      { headers: { Authorization: `Bearer ${userToken}` } }
    );
    if (response.status === 200 && response.data.msg === "Invalid token.") {
      errorMessage();
      return { success: false, msg: "Session expired" };
    }
    return response.data;
  } catch (err) {
    console.error("postApiRaw error:", err);
    return { success: false, msg: err.message || "Network error" };
  }
}

export async function getApi(
  payload = {},
  apiName = "getOrders",
  apiUrl = "ecomm/",
  apiHeader = {},
  // silent: skip error toasts (for background requests); timeout in ms.
  { silent = false, timeout } = {}
) {
  let data = {};
  const tokenString = localStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  
  // Add authentication for payment methods APIs
  if (apiName === "getPaymentMethods" || apiName === "updatePaymentMethod") {
    payload = {
      ...payload,
      key: "JWT",
      secret: "RAPSAP"
    };
  }
  
  await axios
    .post(API_BASE_PATH + apiUrl + apiName, payload, {
      headers: { ...apiHeader, Authorization: `Bearer ${userToken}` },
      timeout,
    })
    .then((res) => {
      if (res.status === 200 && res.data.success) {
        data = res.data;
      } else if (!silent) {
        errorMessage();
      }
    })
    .catch((err) => {
      if (!silent) errorMessage();
      console.log(err);
    });
  return data;
}

export async function saveApi(
  values = {},
  msg = "Order Cancelled",
  apiName = "cancelOrder",
  apiUrl = "ecomm/"
) {
  let data = {};
  const tokenString = localStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  
  // Add authentication for payment methods APIs
  if (apiName === "updatePaymentMethod") {
    values = {
      ...values,
      key: "JWT",
      secret: "RAPSAP"
    };
  }
  
  try {
    const response = await axios.post(
      API_BASE_PATH + apiUrl + apiName, 
      values, 
      {
        headers: { Authorization: `Bearer ${userToken}` },
      }
    );
    
    if (response.status === 200 && response.data.success) {
      data = response.data;
      successMessage(msg);
    } else {
      errorMessage();
    }
  } catch (err) {
    console.error("API Error:", err);
    errorMessage();
  }
  
  return data;
}

export async function fetchApi(apiName = "getConfig", apiUrl = "ecomm/") {
  let data = {};
  const tokenString = localStorage.getItem("token");
  if (tokenString) {
    const userToken = JSON.parse(tokenString);
    await axios
      .get(API_BASE_PATH + apiUrl + apiName, {
        headers: { Authorization: `Bearer ${userToken}` },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          data = res.data.data;
        } else {
          errorMessage();
        }
      })
      .catch((err) => (errorMessage(), console.log(err)));
  }
  return data;
}

export async function fetchGoFrugalStores() {
  const tokenString = localStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  let stores = [];
  await axios
    .post(
      API_BASE_PATH + "dashboard/getGofrugalStores",
      { type: "createstore" },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }
    )
    .then((res) => {
      stores = Array.isArray(res?.data?.eCommerceStores)
        ? res.data.eCommerceStores
        : [];
    })
    .catch((err) => {
      errorMessage("Unable to fetch GoFrugal stores.");
      console.log(err);
    });

  return stores;
}

export function DateFormat(date, formatBy = "DD MMM YY h:mm A") {
  return moment(date, "YYYY-MM-DD hh:mm").format(formatBy);
}

export function successMessage(msg) {
  return message.success({
    content: msg + " Successfully.",
    style: { marginTop: "8vh" },
  });
}

export function errorMessage(msg = "Something went wrong, please try again.") {
  // Offline, the network-error screen explains failures; after a session
  // ends, the session-expired box does.
  if (!navigator.onLine || isSessionEnded()) return;
  return message.error({
    content: msg,
    // Same key collapses identical errors fired together into one toast.
    key: msg,
    style: { marginTop: "8vh" },
  });
}

export function preloadImage(url = '../assets/logoText.png') {
  const newImage = new Image();
  newImage.src = url;
  return;
}
